<template>
    <div>
        <el-menu default-active="0" class="el-menu-group" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="0">文档分类</el-menu-item>
            <el-menu-item index="1">共享文档</el-menu-item>
            <el-menu-item index="2">个人文档</el-menu-item>
            <el-menu-item index="3">下载记录</el-menu-item>
        </el-menu>
        <div style='margin-top:30px'></div>
        <div class="line"></div>
        <v-content0 v-if="itemVal==0"></v-content0>
        <v-content1 v-if="itemVal==1"></v-content1>
        <v-content2 v-if="itemVal==2"></v-content2>
        <v-content2 v-if="itemVal==3"></v-content2>
    </div>
</template>

<script>
import $ from 'jquery';
import vContent0 from './DocShareType.vue';
import vContent1 from './DocShare.vue';
import vContent2 from './DocPerson.vue';
import vContent3 from './DocDown.vue';
export default {

    data() {
        return {
            itemVal:'0',
        };
    },
    created() {

    },
    //页面加载方法
    mounted: function () {

    },
    components: {
        vContent0,
        vContent1,
        vContent2,
        vContent3,
    },

    methods: {
        handleSelect(key, keyPath) {
            this.itemVal = key;
        },
    }
};
</script>

<style scoped>
</style>
